import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropdownSelect from '../components/DropdownSelect';
import FuelForm from './FuelForm';
import { fuelerDB } from '../lib';

class ApparatusFuelContainer extends Component {
    constructor() {
        super();

        this.state = {
            apparatuses: [],
            apparatusDropdownOpen: false,
            selectedApparatus: {},
            submitting: false
        };

        this.selectApparatus = this.selectApparatus.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.isValidApparatus = this.isValidApparatus.bind(this);
    }

    componentWillUnmount() {
        if (this.submissionTimeout) {
            clearTimeout(this.submissionTimeout);
        }
    }

    componentDidMount() {
        this.getAccountApparatuses(this.props.online);
        this.setState({
            selectedApparatus: this.props.loggingApparatus
        });
    }

    getAccountApparatuses(online) {
        fuelerDB.apparatuses.toArray(apparatuses => {
            this.setState({
                apparatuses
            });
        });

        if (online) {
            this.props.api.get(`/apparatuses?limit=10000&filter=apparatusOwnership eq "1"`).then(res => {
                const { apparatuses } = res.data;

                const apparatusesWithName = apparatuses.map(apparatus => {
                    const displayName =
                        apparatus.vehicleNumber !== '' && apparatus.vehicleNumber !== null
                            ? `${apparatus.apparatusID} (${apparatus.vehicleNumber})`
                            : apparatus.apparatusID;
                    return Object.assign({}, apparatus, { displayName });
                });

                fuelerDB.apparatuses.bulkPut(apparatusesWithName);

                this.setState({
                    apparatuses: apparatusesWithName
                });
            });
        }
    }

    selectApparatus(apparatus) {
        this.setState({
            selectedApparatus: apparatus,
            apparatusDropdownOpen: false
        });
    }

    isValidApparatus(selectedApparatus) {
        return !!(Object.keys(selectedApparatus).length && selectedApparatus.constructor === Object);
    }

    submitForm(form) {
        if (this.isValidApparatus(this.state.selectedApparatus)) {
            this.props.onSubmitForm(this.state.selectedApparatus, form);
            this.props.history.push('/confirm');
        } else {
            this.setState(
                {
                    submitting: true
                },
                () => {
                    this.submissionTimeout = setTimeout(() => {
                        this.setState({ submitting: false });
                    }, 300);
                }
            );
        }
    }

    render() {
        return (
            <div>
                <DropdownSelect
                    onClick={() => this.setState({ apparatusDropdownOpen: !this.state.apparatusDropdownOpen })}
                    onSelect={this.selectApparatus}
                    selectedItem={this.state.selectedApparatus.apparatusID}
                    isOpen={this.state.apparatusDropdownOpen}
                    displayNameKey="displayName"
                    defaultText="Select Apparatus"
                    valid={!this.state.submitting || this.isValidApparatus(this.state.selectedApparatus)}
                    isRequired
                    items={this.state.apparatuses.filter(apparatus => apparatus.apparatusID)}
                />
                <FuelForm
                    formData={this.props.formData}
                    onSubmit={this.submitForm}
                    apparatusDropdownOpen={this.state.apparatusDropdownOpen}
                    onFocus={() => this.setState({ apparatusDropdownOpen: false })}
                />
            </div>
        );
    }
}

ApparatusFuelContainer.propTypes = {
    online: PropTypes.bool.isRequired
};

export default ApparatusFuelContainer;



// WEBPACK FOOTER //
// ./src/ApparatusFuel/ApparatusFuelContainer.js